import e from "./_virtual/_rolldown_dynamic_import_helper.mjs";
import t from "./locales/en/common.json.mjs";
import { useContext as n } from "react";
import { createI18nInstance as r, createLocaleProvider as i, defaultNS as a, getTFuncWithNamespace as o, getUseLocoTranslation as s } from "@systemeio/util";
import { useTranslation as c } from "react-i18next";
//#region src/i18n.ts
var l = { en: { common: t } }, u = [a], d = () => u, f = (t, n) => e(/* #__PURE__ */ Object.assign({
	"./locales/ar/common.json": () => import("./locales/ar/common.json.mjs"),
	"./locales/cs/common.json": () => import("./locales/cs/common.json.mjs"),
	"./locales/da/common.json": () => import("./locales/da/common.json.mjs"),
	"./locales/de/common.json": () => import("./locales/de/common.json.mjs"),
	"./locales/el/common.json": () => import("./locales/el/common.json.mjs"),
	"./locales/en/common.json": () => import("./locales/en/common.json.mjs"),
	"./locales/es/common.json": () => import("./locales/es/common.json.mjs"),
	"./locales/fr/common.json": () => import("./locales/fr/common.json.mjs"),
	"./locales/hi/common.json": () => import("./locales/hi/common.json.mjs"),
	"./locales/hu/common.json": () => import("./locales/hu/common.json.mjs"),
	"./locales/id/common.json": () => import("./locales/id/common.json.mjs"),
	"./locales/it/common.json": () => import("./locales/it/common.json.mjs"),
	"./locales/ja/common.json": () => import("./locales/ja/common.json.mjs"),
	"./locales/nl/common.json": () => import("./locales/nl/common.json.mjs"),
	"./locales/no/common.json": () => import("./locales/no/common.json.mjs"),
	"./locales/pl/common.json": () => import("./locales/pl/common.json.mjs"),
	"./locales/pt/common.json": () => import("./locales/pt/common.json.mjs"),
	"./locales/ro/common.json": () => import("./locales/ro/common.json.mjs"),
	"./locales/ru/common.json": () => import("./locales/ru/common.json.mjs"),
	"./locales/sk/common.json": () => import("./locales/sk/common.json.mjs"),
	"./locales/sl/common.json": () => import("./locales/sl/common.json.mjs"),
	"./locales/sq/common.json": () => import("./locales/sq/common.json.mjs"),
	"./locales/sr/common.json": () => import("./locales/sr/common.json.mjs"),
	"./locales/sv/common.json": () => import("./locales/sv/common.json.mjs"),
	"./locales/th/common.json": () => import("./locales/th/common.json.mjs"),
	"./locales/tr/common.json": () => import("./locales/tr/common.json.mjs"),
	"./locales/uk/common.json": () => import("./locales/uk/common.json.mjs"),
	"./locales/zh/common.json": () => import("./locales/zh/common.json.mjs")
}), `./locales/${t}/${n}.json`, 4).then((e) => e.default), { i18n: p } = r({ resources: l }), { LocaleContext: m, LocaleProvider: h } = i(), g = o(p.t, d), _ = s({
	useTranslation: (e, t) => {
		let { i18n: r } = n(m) ?? {};
		return c(e, {
			i18n: r,
			...t
		});
	},
	defaultNamespaces: u,
	namespaceMapper: d
});
//#endregion
export { m as LocaleContext, h as LocaleProvider, p as i18n, f as loadLangBundle, g as t, _ as useTranslation };
